<template>
  <div class="">
    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-4 d-flex">
          <card class="card-eprf">
            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              JOB DETAILS
            </p>
            <div style="height: 520px; overflow: auto; overflow-x: hidden">
              <p class="new-title">Job Reference No.</p>
              <p class="subtitle">{{ jobno }}</p>

              <p class="new-title">Collection Date</p>
              <p class="subtitle">{{ collectiondate }}</p>

              <p class="new-title">Service Location</p>
              <p class="subtitle">{{ servicelocation }}</p>

              <p class="new-title">Service Location Collection</p>
              <p class="subtitle">{{ servicelocationcollection }}</p>

              <p class="new-title">Company Name</p>
              <p class="subtitle">{{ companyName }}</p>

              <p class="new-title">Company Address</p>
              <p class="subtitle">{{ companyAddress }}</p>

              <p class="new-title">Phone No. / Fax No.</p>
              <p class="subtitle">{{ phoneNoFaxNo }}</p>

              <p class="new-title">PIC Full Name</p>
              <p class="subtitle">{{ picFullName }}</p>

              <p class="new-title">PIC Phone No. / Fax No.</p>
              <p class="subtitle">{{ picPhoneNoFaxNo }}</p>

              <p class="new-title">PIC Email</p>
              <p class="subtitle">{{ picEmail }}</p>
            </div>
          </card>
        </div>
        <div class="col-lg-8 d-flex" v-if="generate == true">
          <card class="card-eprf">
            <div class="row">
              <div class="col-lg">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  WASTE DELIVERY ORDER (WDO)
                </p>
              </div>
            </div>
            <div class="row" style="height: 520px; overflow: auto; overflow-x: hidden">
              <div class="col-lg">
                <!--   :cell-class-name="evenclass" -->
                <el-table :data="wastedetails" :header-cell-style="{
                  background: '#358DCC',
                  border: 'transparent',
                  'font-size': '14px',
                  'font-weight': '400',
                  color: '#FFFFFF',
                }" :cell-style="{ fontColor: '#707070' }" :row-style="tableRowClassName">
                  <el-table-column label="No." width="50" align="center">
                    <div slot-scope="scope">
                      <p style="color: #707070">{{ scope.$index + 1 }}</p>
                    </div>
                  </el-table-column>

                  <el-table-column label="Waste Type" prop="wastetype" width="300">
                    <div slot-scope="{ row }">
                      <div class="row">
                        <div class="col-lg">
                          <p style="color: #A5A5A5">{{ row.wastetype }}</p>
                          <p style="color: #A5A5A5">
                            Packaging Type: {{ row.packagingtype }}
                          </p>
                          <br />
                          <p style="color: #A5A5A5">Waste Origin</p>
                          <p style="color: #A5A5A5; font-weight: bold">
                            {{ row.wasteorigin }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </el-table-column>
                  <el-table-column label="Waste Component" prop="wastecomponent" width="160">
                    <div slot-scope="{ row }">
                      <p style="color: #A5A5A5" v-for="(item, index) in row.wastecomponent" :key="index">
                        {{ index + 1 }}. {{ item.component_name == null || item.component_name == '' ? 'N/A' : item.component_name }}
                      </p>
                    </div>
                  </el-table-column>
                  <el-table-column label="Est. Qty" prop="estqty" width="120">
                    <div slot-scope="{ row }">
                      <p style="color: #A5A5A5">
                        {{ row.estqty }} {{ row.estqtyunit }}
                      </p>
                      <p style="color: #A5A5A5">
                        {{ row.packagingqty }} {{ row.packagingqtyunit }}
                      </p>
                    </div>
                  </el-table-column>
                  <el-table-column label="Actual Qty" prop="estqty" width="130">
                    <div slot-scope="{ row }">
                      <p style="color: #A5A5A5">
                        {{ row.calqty }} {{ row.calqtyunit }}
                      </p>

                    </div>
                  </el-table-column>
                  <el-table-column label="Remarks" prop="remarks"></el-table-column>
                </el-table>
              </div>
            </div>
            <!-- <div class="row">
              <div class="col-lg text-left">
                <p style="color: #A5A5A5; font-weight: bold">Lab Report</p>
                <p style="color: #A5A5A5">Please upload lab report</p>
                <label for="lab-report" type="primary" class="btn" style="
                    font-size: 13px;
                    color: #ffffff;
                    text-transform: capitalize;
                  ">
                  Choose File
                </label>
                <div class="d-flex justify-content-center spinner" v-if="uploadlabreport == true">
                  <circle-8></circle-8>
                </div>
                <input type="file" name="..." id="lab-report" ref="labreport" @change="onfilechange" :multiple="true"
                  style="display: none;" />
              </div>
              <div class="col-lg-6 text-right">
                <div class="row" v-for="(item, index) in labreport" :key="index">
                  <div class="col-lg">
                    <a :href="item.url">
                      <base-button class="btn-link btn-primary">

                        {{ item.meta.filename }}
                      </base-button>
                    </a>
                    <p style="color: #A5A5A5"></p>
                  </div>
                  <div class="col-lg">
                    <base-button class="btn-sm btn-cancel" style="font-size: 12px; "
                      @click="removelabreport(item.lab_report_id)">Remove</base-button>
                  </div>
                </div>
              </div>
            </div> -->
          </card>
        </div>
        <div class="col-lg-8 d-flex" v-if="generate == false">
          <card class="card-eprf">
            <div class="row">
              <div class="col-lg">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  WASTE DELIVERY ORDER (WDO)
                </p>
              </div>
            </div>
            <div style="height: 520px; overflow: auto; overflow-x: hidden">
              <div v-if="positionid != 4">
                <p style="margin-top: 50px" class="newtitle">
                  View Your Generated WDO
                </p>
                <!-- <base-button type="primary" @click="dunlud">View</base-button> -->
                <base-button type="primary" @click="createWDO">View</base-button>

                <!-- <div class="col-lg-12">
                  <p style="color: #A5A5A5; font-weight: bold">Edit WDO</p>
                </div>
                <div class="col-lg-12">
                  <base-button @click="generate = true">Edit</base-button>
                </div> -->
              </div>

              <div class="row">
                <div class="col-lg-12">
                  <p style="margin-top: 50px" class="newtitle" v-if="positionid != 4 && step < 6">
                    Choose File from Your Desktop
                  </p>
                  <p style="margin-top: 50px" class="newtitle" v-if="positionid != 4 && step == 6">
                    Signed WDO
                  </p>
                  <p style="margin-top: 50px" class="newtitle" v-if="positionid == 4">
                    Signed WDO
                  </p>
                  <p class="sub-titles" v-if="positionid != 4 && step < 6">
                    Please upload signed WDO
                  </p>
                  <!-- <p class="sub-titles" v-if="positionid == 4">Signed WDO</p> -->
                </div>
                <div class="col-lg-12" v-if="positionid != 4 && step < 6">
                  <label for="signed-wdo" type="primary" class="btn" style="
                      font-size: 13px;
                      color: #ffffff;
                      text-transform: capitalize;
                    ">
                    Choose File
                  </label>
                  <div class="d-flex justify-content-center spinner" v-if="uploadloadsigned == true">
                    <circle-8></circle-8>
                  </div>
                  <input style="display: none" type="file" name="..." id="signed-wdo" ref="signeddo"
                    @change="onwdochange" :multiple="true" />
                </div>
              </div>
              <div style="
                  height: 150px;
                  padding: 0px 20px 20px 0px;
                  margin: 0px 30px 20px 0px;
                " class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto">
                <div class="row" v-for="(filee, index) in signeddo" :key="index">
                  <div class="col-lg">
                    Rev {{ filee.rev }}
                    <a :href="filee.url">
                      <base-button class="btn-link btn-primary">
                        {{ filee.filename }}
                      </base-button>
                    </a>
                  </div>
                  <div class="col-lg">
                    <base-button class="btn-sm btn-cancel" style="font-size: 12px" v-if="positionid != 4 && step < 6"
                      @click="removesigneddo(filee.fileid)">Remove</base-button>
                  </div>
                </div>
              </div>
              <br />
              <!-- <div class="row">
                <div class="col-lg-12">
                  <p style="color: #A5A5A5; font-weight: bold">Generated WDO</p>
                </div>
                <div class="col-lg-12">
                  <base-button>Generate</base-button>
                </div>
              </div> -->
            </div>
          </card>
        </div>
        <!-- <div class="col-lg-4">
          <card
            style="
              box-shadow: none;
              padding: 0px 0px 30px 30px;
              height: 630px;
              background-color: white;
            "
          >
            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              CUSTOMER DETAILS
            </p>

            <p class="new-title">Company Name</p>
            <p class="subtitle">Ombak Biru Holdings</p>

            <p class="new-title" style="padding-top: 50px">Company Address</p>
            <p class="subtitle">
              202, Jalan Port Klang Pelabuhan, 42005 Selangor, Malaysia
            </p>

            <p class="new-title" style="padding-top: 50px">
              Phone No. / Fax No.
            </p>
            <p class="subtitle">+603 4562 7890</p>
          </card>
        </div>
        <div class="col-lg-4">
          <card
            style="
              box-shadow: none;
              padding: 0px 0px 30px 30px;
              height: 630px;
              background-color: white;
            "
          >
            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              PIC DETAILS
            </p>

            <p class="new-title">Full Name</p>
            <p class="subtitle">Amirah binti Azman</p>

            <p class="new-title" style="padding-top: 50px">
              Phone No. / Fax No.
            </p>
            <p class="subtitle">+019 562 7890</p>

            <p class="new-title" style="padding-top: 50px">Email</p>
            <p class="subtitle">amirah@ombakb.com.my</p>
          </card>
        </div>
      
        <div class="col-lg-4">
          <card
            style="
              box-shadow: none;
              padding: 0px 0px 30px 30px;
              height: 630px;
              background-color: white;
            "
          >
            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              SHIP DETAILS
            </p>

            <div
              style="margin-left: -30px"
              class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto"
            >
              <p class="new-title">Ship Name</p>
              <p class="subtitle">Eagle 01</p>

              <p class="new-title">IMO No.</p>
              <p class="subtitle">8814275</p>

              <p class="new-title">Ship Type</p>
              <p class="subtitle">Oil tanker</p>
              <p class="new-title">Gross Tonnage</p>
              <p class="subtitle">220,000</p>

              <p class="new-title">Deadweight Tonnage (kg)</p>
              <p class="subtitle">+019 562 7890</p>

              <p class="new-title">Owner / Operator Name</p>
              <p class="subtitle">Rizal bin Abdullah</p>

              <p class="new-title">Call Sign</p>
              <p class="subtitle">Starlight</p>

              <p class="new-title">Flag State</p>
              <p class="subtitle">Malaysia</p>

              <p class="new-title">Sustainable Certificates</p>
              <p class="subtitle">1 - ISO 14001.pdf</p>
              <p class="subtitle">2 - EU Ecolabel.pdf</p>
            </div>
          </card>
        </div>
        <div class="col-lg-4">
          <card
            style="
              box-shadow: none;
              padding: 0px 0px 30px 30px;
              height: 630px;
              background-color: white;
            "
          >
            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              WASTE TO BE COLLECTED
            </p>
            <p class="new-title">Waste Type</p>
            <p class="subtitle">Annex I - Oily bilge water</p>

            <p class="new-title" style="padding-top: 50px">Waste Quantity</p>
            <p class="subtitle">300 MT</p>

            <p class="new-title" style="padding-top: 50px">
              Max Dedicated Storage Capacity
            </p>
            <p class="subtitle">500 MT</p>
 
            <p class="new-title" style="padding-top: 50px">
              Amount of Waste Retained Onboard
            </p>
            <p class="subtitle">50 MT</p>
          </card>
        </div> -->
      </div>
      <div class="row">
        <div class="col-lg text-right">
          <base-button v-if="generate == true" wide type="danger" @click.native="prevTab" class="btn-previous">
            BACK
          </base-button>
          <base-button v-if="generate == false" wide type="danger" @click.native="generate = true" class="btn-previous">
            BACK
          </base-button>
          <base-button type="primary" v-if="generate == false" wide @click.native="nextTab" class="btn-next">
            NEXT
          </base-button>
          <!-- call generate wdr api -->
          <base-button type="primary" v-if="generate == true && positionid != 4" wide @click="generated()"
            class="btn-next">
            NEXT
          </base-button>
          <base-button type="primary" v-if="generate == true && positionid == 4" wide @click="generate = false"
            class="btn-next">
            NEXT
          </base-button>
        </div>
      </div>
    </div>
    <StatusModal :show.sync="modals.removeModal" :message="modal.remove" :title="modal.removeTitle" />
    <StatusModal :show.sync="modals.successModal" :message="modal.success" :title="modal.successTitle" />
    <modal :show.sync="modals.disputereason" class="modal-eprf" centered>
      <b-card class="card text-center" style="background-color: #f5f6fa; box-shadow: none" border-variant="primary"
        header="REASON FOR DISPUTE" header-bg-variant="primary" header-text-variant="white">
        <template #header>
          <div class="row">
            <div class="col-lg text-left">
              <h4 class="mb-0">REASON FOR DISPUTE</h4>
            </div>
            <div class="col-lg-3 text-right" style="padding-bottom: 10px">
              <base-button class="btn-icon btn-cancel btn-round btn-sm">
                <i style="
                    transform: translate(-50%, -50%);
                    color: white;
                    font-weight: 900;
                    font-size: 12px;
                  " class="tim-icons icon-simple-remove" @click="modals.disputereason = false"></i>
              </base-button>
            </div>
          </div>
        </template>

        <div class="row">
          <div class="col-lg-12">
            <textarea type="textarea" placeholder="Reason for rejection..." v-model="reason"
              :class="{ textarea: true }"></textarea>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-1">
            <div class="fileinput">
              <label style="
                  font-size: 13px;
                  color: #ffffff;
                  text-transform: capitalize;
                " for="file-upload" type="primary" class="btn">
                Upload
              </label>

              <div class="d-flex justify-content-center spinner" v-if="this.uploadload == true">
                <circle-8></circle-8>
              </div>

              <input accept="application/pdf" id="file-upload" ref="file" type="file" name="..." class="valid"
                :multiple="true" aria-invalid="false" style="display: none" v-on:change="onFileChange" />
            </div>
          </div>

          <div class="col-lg"></div>
          <div class="col-lg-4 text-right">
            <base-button type="primary" v-on:click="dispute()">Submit</base-button>
          </div>
        </div>
      </b-card>
    </modal>
    <modal :show.sync="modals.image" class="modal-eprf">
      <!-- <div class="row" style="position: fixed; right: 0; top: 0;">
        <div class="col-lg-12 text-right" style="margin-bottom: 50px">
          <base-button class="btn-link" type="primary" v-on:click="modals.image = false"
            ><i class="tim-icons icon-simple-remove" style="font-size:50px"></i></base-button
          >
        </div>
      </div> -->
      <div class="row">
        <div class="col-lg">
          <img :src="image" />
        </div>
      </div>
    </modal>
    <!-- <div class="col-lg-12">
      <div class="row">
        <div class="col-lg"></div>
        <div class="col-lg-3 text-right">
          <base-button type="danger" v-on:click="getBack()">Cancel</base-button
          >&nbsp;
          <base-button type="primary" v-on:click="handleDone()">Done</base-button>
        </div>
      </div>
      <div class="row">
        <div class="col-lg"></div>
        <div class="col-lg-3 text-right">
          <p

            style="text-decoration: underline"
            @click="saveDraft()"
          >
            Save Draft
          </p>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  Option,
  Select,
  DatePicker,
  TimePicker,
  TimeSelect,
} from "element-ui";
import moment, { utc } from "moment";
import swal from "sweetalert2";
import { ImageUpload, Modal } from "src/components";
import { colors } from "../../../../../components/colors.js";
import { BCard } from "bootstrap-vue";
import { Circle8 } from "vue-loading-spinner";
import StatusModal from "src/components/StatusModal.vue";
import { modal } from "src/components/variable.js";
//import { position } from "html2canvas/dist/types/css/property-descriptors/position";
import jsPDF from "jspdf";

export default {
  props: ["parentData"],
  name: "first-step",
  components: {
    BCard,
    StatusModal,
    colors,
    ImageUpload,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [TimePicker.name]: TimePicker,
    Modal,
    Circle8,
  },
  props: ["first-step"],
  data() {
    return {
      wastecomponent: [],

      modal: modal,
      uploadlabreport: false,
      uploadloadsigned: false,
      generate: true,
      labreport: [],
      signeddo: [],
      cancelledref: "",
      cancelledrefs: [],
      uploadload: false,
      step: 0,
      jobno: "",
      collectiondate: "",
      servicelocation: "",
      servicelocationcollection: "",
      arrivalETA: "18 Nov 2022",
      departureETD: "15 Nov 2022",
      issueDate: "",
      companyName: "",
      companyAddress: "",
      phoneNoFaxNo: "",
      picFullName: "",
      picPhoneNoFaxNo: "",
      picEmail: "",
      previousPort: "None",
      nextPort: "None",
      lastPortAndDate: "None",
      reason: "",
      wastedetails: [
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
          wastetype: "Scheduled Waste",
          wastecatalyst: "SW 202 - Waste Catalysts",
          packagingtype: "Packaging Type : Drum",
          wasteorigin: "Steel Factory",
          wastecomponent: [
            {
              item: "Iron",
            },
            {
              item: "Water",
            },
          ],
          estqty: "300 M3",
        },
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
          wastetype: "Scheduled Waste",
          wastecatalyst: "SW 202 - Waste Catalysts",
          packagingtype: "Packaging Type : Drum",
          wasteorigin: "Steel Factory",
          wastecomponent: [
            {
              item: "Iron",
            },
            {
              item: "Water",
            },
          ],
          estqty: "300 M3",
        },
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
          wastetype: "Scheduled Waste",
          wastecatalyst: "SW 202 - Waste Catalysts",
          packagingtype: "Packaging Type : Drum",
          wasteorigin: "Steel Factory",
          wastecomponent: [
            {
              item: "Iron",
            },
            {
              item: "Water",
            },
          ],
          estqty: "300 M3",
        },
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
          wastetype: "Scheduled Waste",
          wastecatalyst: "SW 202 - Waste Catalysts",
          packagingtype: "Packaging Type : Drum",
          wasteorigin: "Steel Factory",
          wastecomponent: [
            {
              item: "Iron",
            },
            {
              item: "Water",
            },
          ],
          estqty: "300 M3",
        },
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
          wastetype: "Scheduled Waste",
          wastecatalyst: "SW 202 - Waste Catalysts",
          packagingtype: "Packaging Type : Drum",
          wasteorigin: "Steel Factory",
          wastecomponent: [
            {
              item: "Iron",
            },
            {
              item: "Water",
            },
          ],
          estqty: "300 M3",
        },
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
          wastetype: "Scheduled Waste",
          wastecatalyst: "SW 202 - Waste Catalysts",
          packagingtype: "Packaging Type : Drum",
          wasteorigin: "Steel Factory",
          wastecomponent: [
            {
              item: "Iron",
            },
            {
              item: "Water",
            },
          ],
          estqty: "300 M3",
        },
      ],
      scroll: false,
      img: null,
      imgdescription: "",
      image: "",
      imagebase64: "",
      images: {
        regular: null,
      },
      jobstatus: "",
      landvesselflag: "",
      modals: {
        disputereason: false,
        successModal: false,
        removeModal: false,
        image: false,
      },
      message: "",
      positionid: "",
    };
  },
  created() {
    // this.jobstatus = this.$route.params.jobnum.split("_")[1];

    this.jobno = this.$route.params.jobnum.split("_")[0];
    this.getDetail(this.jobno);
    this.positionid = parseInt(
      JSON.parse(atob(sessionStorage.getItem("token").split(".")[1]))
        .position_id
    );
    // this.getCancelRef(this.jobno);
  },
  mounted() { },

  methods: {
    onwdochange(e) {
      this.uploadloadsigned = true;
      const formData = new FormData();
      for (let i = 0; i < e.target.files.length; i++) {
        var input = this.$refs.signeddo.files[i];
        formData.append("document", input);
      }

      this.$http
        .post(
          ":10001/api/v1/incoming/" + this.jobno + "/signed-wdo",
          formData,
          {
            headers: {
              Authorization: "Bearer " + sessionStorage.getItem("token"),
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);

            this.message = response;
            this.modals.successModal = true;
            this.uploadloadsigned = false;
            this.getDetail(this.jobno);

          } else {
          }
        });
      e.target.value = ''
    },
    nextTab() {
      console.log("kau ke panggil");
      let parameter = {
        step: "5",
        direction: "depan",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    prevTab() {
      let parameter = {
        step: "5",
        direction: "blkg",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    removesigneddo(id) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this action!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          this.$http
            .delete(":10001/api/v1/incoming/" + this.jobno + "/signed-wdo")
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.removeModal = true;

                this.getDetail(this.jobno);
              } else {
                let response = res.message;
                this.message = response;
                // this.modals.failedModal2 = true;
              }
            });
        }
      });
    },
    removelabreport(id) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this action!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          this.$http
            .delete(":10001/api/v1/incoming/" + this.jobno + "/lab-report")
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.removeModal = true;

                this.getDetail(this.jobno);
              } else {
                let response = res.message;
                this.message = response;
                // this.modals.failedModal2 = true;
              }
            });
        }
      });
    },
    onfilechange(e) {
      this.uploadlabreport = true;
      const formData = new FormData();
      for (let i = 0; i < e.target.files.length; i++) {
        var input = this.$refs.labreport.files[i];

        formData.append("document", input);
      }

      this.$http
        .post(
          ":10001/api/v1/incoming/" + this.jobno + "/lab-report",
          formData,
          {
            headers: {
              Authorization: "Bearer " + sessionStorage.getItem("token"),
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            this.message = response;
            this.modals.successModal = true;
            this.getDetail(this.jobno);
            this.uploadlabreport = false;
          } else {
          }
        });
    },
    openimage(url) {
      this.image = url;
      this.modals.image = true;
    },
    sendCancelledRef() {
      let obj = {
        reference_number: this.cancelledref,
      };

      this.$http
        .post(":10001/api/v1/incoming/" + this.jobno + "/accept ")
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = response;
            this.modals.successModal = true;
          }
        });
    },
    getCancelRef(refno) {
      console.log(refno);

      this.$http
        .get(":10001/api/v1/incoming/" + refno + "/cancelled-ref")
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);

            for (var i = 0; i < response.reference_number.length; i++) {
              let obj = {
                value: response.reference_number[i],
                label: response.reference_number[i],
              };
              this.cancelledrefs.push(obj);
            }
          }
        });
    },
    async viewGeneratedQuo() {
      await this.$http
        .get(":10001/api/v1/incoming/" + this.jobno + "/do/generate")
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            this.issueDate = moment(response.wdr_issued_at).format(
              "DD.MM.YYYY"
            );

            console.log("dapat date" + this.issueDate);
          }
        });
    },
    async generated() {
      try {
        console.log("masuk tak ek");
        await this.$http
          .post(":10001/api/v1/incoming/" + this.jobno + "/generate-wdr")
          .then((res) => {
            if (!res.error) {
              console.log(res);
              console.log("tak errorr");
              this.generate = false;
              this.viewGeneratedQuo();
            } else {
              console.log("errorr");
              // this.modals.warningsubmit = false;

              swal({
                title: "Operation incomplete!",
                text: `Waiting for operation to complete.`,
                type: "warning",
                confirmButtonClass: "btn btn-success btn-fill",
                confirmButtonText: "Okay",
                buttonsStyling: false,
              });
              this.generate = true;
            }
            console.log("pastu");
          });
      } catch (error) {
        console.error("Request failed", error);

        // Handle unexpected errors
        swal({
          title: "Operation incomplete!",
          text: "Waiting for operation to complete.",
          type: "warning",
          confirmButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "Okay",
          buttonsStyling: false,
        });
        this.generate = true;
      }
      console.log("masuk kot");
    },
    //buat pdf sini
    createWDO() {
      let doc = jsPDF({
        orientation: "potrait",
      });

      const logo = new Image();
      logo.src = require("@/assets/img/afesnew.png");
      logo.onload = () => {
        this.options = Object.assign({}, this.options, {
          logo: {
            logo,
          },
        });
      };



      // Example data to include in the PDF
      const data = this.wastedetails;

      const customRow = "\t\t\t\t\t\t\tWASTE PARTICULARS";

      // Define the columns for the table
      const columns = [
        "No.",
        "\t\t\t\tWaste Code or Waste Description",
        "Packaging",
        "Quantity (MT)",
      ];
      // Define the rows for the table
      const rows = data.map((obj) => [obj.no, obj.waste, obj.pack, obj.est]);

      // Add logo image on top right
      doc.addImage(
        logo,
        "PNG",
        doc.internal.pageSize.getWidth() - 75,
        5,
        50,
        18.75
      ); // Adjust position and dimensions as needed

      // Add title "Quotation" on top left
      doc.setFontSize(21);
      doc.setFontStyle("bold");
      doc.text("WASTE DELIVERY ORDER", 15, 40);
      doc.setFontSize(11);
      doc.setFontStyle("normal");
      // doc.text("DHES SST ID No :", 130, 40);
      doc.setFontStyle("bold");

      doc.text("CUSTOMER DETAIL", 20, 55);

      doc.text(this.picFullName, 20, 60);
      doc.setFontStyle("normal");
      doc.text(this.companyName, 20, 65);
      var companyAddress = this.companyAddress;
      var maxCharactersPerLine = 40;

      function splitTextIntoLines(text, maxLength) {
        var lines = [];
        while (text.length > maxLength) {
          var line = text.substring(0, maxLength);
          var lastSpace = line.lastIndexOf(" ");
          if (lastSpace !== -1) {
            lines.push(line.substring(0, lastSpace));
            text = text.substring(lastSpace + 1);
          } else {
            lines.push(line);
            text = text.substring(maxLength);
          }
        }
        lines.push(text);
        return lines;
      }

      var addressLines = splitTextIntoLines(
        companyAddress,
        maxCharactersPerLine
      );

      for (var i = 0; i < addressLines.length; i++) {
        var yPos = 70 + i * 5;
        doc.text(addressLines[i], 20, yPos);
      }

      var boxheight = addressLines.length * 14.5;
      doc.setDrawColor(0, 0, 0);


      doc.rect(15, 50, 80, boxheight);

      var squareX = 110;
      var squareY = 50;
      var squareWidth = 85;
      // var squareHeight = 26; // Adjusted height
      var squareHeight = 20; // Adjusted height

      doc.setDrawColor(0, 0, 0);

      // Draw a square
      doc.rect(squareX, squareY, squareWidth, squareHeight);

      // // Set up text
      var textX = squareX + 5; // Adjust this value as needed for text position
      var textY = squareY + 7; // Adjust this value as needed for text position
      var lineHeight = 7; // Adjust this value as needed for line spacing

      // // Add text inside the square
      doc.text("Delivery Order No.", textX, textY);
      doc.text("Date", textX, textY + lineHeight);
      // doc.text("WCO No", textX, textY + lineHeight + lineHeight);

      // // Add colons
      doc.text(" : ", textX + 35, textY);
      doc.text(" : ", textX + 35, textY + lineHeight);
      // doc.text(" : ", textX + 35, textY + lineHeight + lineHeight);

      // // Add dynamic data
      doc.text(this.jobno, textX + 38, textY);
      doc.text(this.issueDate, textX + 38, textY + lineHeight);
      // doc.text('linked reference no', textX + 38, textY + lineHeight + lineHeight);

      const columnss = [
        "\t\t\t\t\t\t\t\t\tJOB PARTICULAR",
      ];

      const datass = [
        {
          a: "\nDate\t: \t" + this.collectiondate + " \nWaste Collection Location\t: \t" + this.servicelocationcollection + " \nVehicle Registration Number\t: \t- \nName of Driver\t: \t- \n "
        }
      ]

      const rowss = datass.map((obj) => [
        obj.a,
      ]);

      doc.setFontSize(11);

      // doc.setDrawColor(200, 200, 200);
      // doc.rect(14, 89, 181.5, 10);
      // doc.setFontStyle("bold");

      // doc.text("\tJOB PARTICULAR", 80, 95);

      const tablefirst = doc.autoTable({
        head: [columnss],
        body: rowss,
        startY: 60 + boxheight,
        theme: "plain",

        columnStyles: {
          0: { columnWidth: 182, },
        },

        didDrawCell: function (data) {
          doc.setDrawColor(0, 0, 0);
          doc.rect(
            data.cell.x,
            data.cell.y,
            data.cell.width,
            data.cell.height,
            "S"
          );
        },

        // styles: {
        //   fontSize: 7,
        // },
      });

      doc.setDrawColor(0, 0, 0);
      doc.rect(14.14, 129.8, 181.7, 10);
      doc.setFontStyle("bold");

      doc.text("WASTE PARTICULAR", 80, 12 + tablefirst.autoTable.previous.finalY);

      const table = doc.autoTable({
        head: [columns],
        columnStyles: {
          0: {
            halign: "center",
            cellWidth: 9,
          },
          1: {
            // columnWidth: 100,
          },
          2: {
            halign: "center",
            cellWidth: 21,
          },
          3: {
            halign: "center",
            cellWidth: 27,
          },
        },
        theme: "plain",
        body: rows,
        startY: 15.4 + tablefirst.autoTable.previous.finalY,
        didDrawCell: function (data) {
          doc.setDrawColor(0, 0, 0);
          doc.rect(
            data.cell.x,
            data.cell.y,
            data.cell.width,
            data.cell.height,
            "S"
          );
        },
      });

      let tableHeight = table.autoTable.previous.finalY;

      if (tableHeight > doc.internal.pageSize.getHeight() - 10) {
        doc.addPage();
        tableHeight = 20;
      }

      // const tableHeight = table.autoTable.previous.finalY - 50;
      doc.setFontStyle("bold");

      doc.text(this.companyName, 15, tableHeight + 12);
      doc.setFontStyle("normal");

      // doc.text(this.locationname, 15, tableHeight + 67);
      doc.text(
        "I/We hereby accept the above services in a good order and condition:-",
        15,
        tableHeight + 27
      );
      doc.text("Name", 15, tableHeight + 37);
      doc.text(": ___________________________________", 55, tableHeight + 37);

      doc.text("Signature", 15, tableHeight + 47);
      doc.text(": ___________________________________", 55, tableHeight + 47);

      doc.text("Company Stamp", 15, tableHeight + 57);
      doc.text(": ", 55, tableHeight + 57);
      doc.setFontStyle("bold");

      doc.text(
        "Alam Flora Environmental Solutions Sdn. Bhd. (AFES)",
        55,
        tableHeight + 82
      );
      // doc.setFontSize(8);
      doc.setFontStyle("italic");
      doc.setFontStyle("normal");

      doc.text(
        "(previously known as DRB-HICOM Environmental Services Sdn Bhd)",
        45,
        tableHeight + 87
      );
      doc.setFontSize(11);
      doc.text(
        "Level 2, EON Head Office Complex, 2, Persiaran Kerjaya U1",
        55,
        tableHeight + 97
      );
      doc.text(
        "40150 Shah Alam, Selangor Darul Ehsan, MALAYSIA",
        60,
        tableHeight + 102
      );
      doc.text(
        "Tel: (603) 7803 0518 Fax: (603) 7809 0137 Web: www.afes.com.my",
        45,
        tableHeight + 107
      );

      doc.save("Waste Delivery Order.pdf");
    },
    // createWDO() {
    //   var doc = new jsPDF();

    //   const logo = new Image();
    //   logo.src = require("@/assets/img/afesnew.png");
    //   logo.onload = () => {
    //     this.options = Object.assign({}, this.options, {
    //       logo: {
    //         logo,
    //       },
    //     });
    //   };

    //   // Example data to include in the PDF
    //   const data = this.wastedetails;

    //   const customRow = "\t\t\t\t\t\t\tWASTE PARTICULARS";

    //   // Define the columns for the table
    //   const columns = [
    //     "No.",
    //     "\t\t\t\tWaste Code or Waste Description",
    //     "Packaging",
    //     "Quantity (MT)",
    //   ];
    //   // Define the rows for the table
    //   const rows = data.map((obj) => [obj.no, obj.waste, obj.pack, obj.est]);

    //   // Add logo image on top right
    //   doc.addImage(
    //     logo,
    //     "PNG",
    //     doc.internal.pageSize.getWidth() - 75,
    //     0,
    //     65,
    //     50
    //   ); // Adjust position and dimensions as needed

    //   // Add title "Quotation" on top left
    //   doc.setFontSize(21);
    //   doc.setFontStyle("bold");
    //   doc.text("WASTE DELIVERY ORDER", 15, 40);
    //   doc.setFontSize(11);
    //   doc.setFontStyle("normal");
    //   // doc.text("DHES SST ID No :", 130, 40);
    //   doc.setFontStyle("bold");

    //   doc.text("CUSTOMER DETAIL", 20, 55);

    //   doc.text(this.picFullName, 20, 60);
    //   doc.setFontStyle("normal");
    //   doc.text(this.companyName, 20, 65);
    //   var companyAddress = this.companyAddress;
    //   var maxCharactersPerLine = 40;

    //   function splitTextIntoLines(text, maxLength) {
    //     var lines = [];
    //     while (text.length > maxLength) {
    //       var line = text.substring(0, maxLength);
    //       var lastSpace = line.lastIndexOf(" ");
    //       if (lastSpace !== -1) {
    //         lines.push(line.substring(0, lastSpace));
    //         text = text.substring(lastSpace + 1);
    //       } else {
    //         lines.push(line);
    //         text = text.substring(maxLength);
    //       }
    //     }
    //     lines.push(text);
    //     return lines;
    //   }

    //   var addressLines = splitTextIntoLines(
    //     companyAddress,
    //     maxCharactersPerLine
    //   );

    //   for (var i = 0; i < addressLines.length; i++) {
    //     var yPos = 70 + i * 5;
    //     doc.text(addressLines[i], 20, yPos);
    //   }

    //   var boxheight = addressLines.length * 14.5;

    //   doc.rect(15, 50, 80, boxheight);

    //   var squareX = 110;
    //   var squareY = 50;
    //   var squareWidth = 85;
    //   // var squareHeight = 26; // Adjusted height
    //   var squareHeight = 20; // Adjusted height

    //   // Draw a square
    //   doc.rect(squareX, squareY, squareWidth, squareHeight);

    //   // // Set up text
    //   var textX = squareX + 5; // Adjust this value as needed for text position
    //   var textY = squareY + 7; // Adjust this value as needed for text position
    //   var lineHeight = 7; // Adjust this value as needed for line spacing

    //   // // Add text inside the square
    //   doc.text("Delivery Order No.", textX, textY);
    //   doc.text("Date", textX, textY + lineHeight);
    //   // doc.text("WCO No", textX, textY + lineHeight + lineHeight);

    //   // // Add colons
    //   doc.text(" : ", textX + 35, textY);
    //   doc.text(" : ", textX + 35, textY + lineHeight);
    //   // doc.text(" : ", textX + 35, textY + lineHeight + lineHeight);

    //   // // Add dynamic data
    //   doc.text(this.jobno, textX + 38, textY);
    //   doc.text(this.issueDate, textX + 38, textY + lineHeight);
    //   // doc.text('linked reference no', textX + 38, textY + lineHeight + lineHeight);
    //   doc.setDrawColor(200, 200, 200);
    //   doc.rect(14.3, 89, 181.5, 10);
    //   doc.setFontStyle("bold");

    //   doc.text("WASTE PARTICULAR", 80, 95);

    //   const table = doc.autoTable({
    //     head: [columns],
    //     columnStyles: {
    //       0: {
    //         halign: "center",
    //         cellWidth: 10,
    //       },
    //       1: {
    //         // columnWidth: 100,
    //       },
    //       2: {
    //         halign: "center",
    //         cellWidth: 21,
    //       },
    //       3: {
    //         halign: "center",
    //         cellWidth: 27,
    //       },
    //     },
    //     theme: "plain",
    //     body: rows,
    //     startY: 69.9 + boxheight,
    //     didDrawCell: function (data) {
    //       doc.rect(
    //         data.cell.x,
    //         data.cell.y,
    //         data.cell.width,
    //         data.cell.height,
    //         "S"
    //       );
    //     },
    //   });

    //   let tableHeight = table.autoTable.previous.finalY + 100;

    //   if (tableHeight > doc.internal.pageSize.getHeight() - 10) {
    //     doc.addPage();
    //     tableHeight = 20;
    //   }

    //   // const tableHeight = table.autoTable.previous.finalY - 50;
    //   doc.setFontStyle("bold");

    //   doc.text(this.companyName, 15, tableHeight + 12);
    //   doc.setFontStyle("normal");

    //   // doc.text(this.locationname, 15, tableHeight + 67);
    //   doc.text(
    //     "I/We hereby accept the above services in a good order and condition:-",
    //     15,
    //     tableHeight + 27
    //   );
    //   doc.text("Name", 15, tableHeight + 37);
    //   doc.text(": ___________________________________", 55, tableHeight + 37);

    //   doc.text("Signature", 15, tableHeight + 47);
    //   doc.text(": ___________________________________", 55, tableHeight + 47);

    //   doc.text("Company Stamp", 15, tableHeight + 57);
    //   doc.text(": ", 55, tableHeight + 57);
    //   doc.setFontStyle("bold");

    //   doc.text(
    //     "Alam Flora Environmental Solutions Sdn. Bhd. (AFES)",
    //     55,
    //     tableHeight + 112
    //   );
    //   // doc.setFontSize(8);
    //   doc.setFontStyle("italic");
    //   doc.setFontStyle("normal");

    //   doc.text(
    //     "(previously known as DRB-HICOM Environmental Services Sdn Bhd)",
    //     45,
    //     tableHeight + 117
    //   );
    //   doc.setFontSize(11);
    //   doc.text(
    //     "Level 2, EON Head Office Complex, 2, Persiaran Kerjaya U1",
    //     55,
    //     tableHeight + 127
    //   );
    //   doc.text(
    //     "40150 Shah Alam, Selangor Darul Ehsan, MALAYSIA",
    //     60,
    //     tableHeight + 132
    //   );
    //   doc.text(
    //     "Tel: (603) 7803 0518 Fax: (603) 7809 0137 Web: www.afes.com.my",
    //     45,
    //     tableHeight + 137
    //   );

    //   doc.save("Waste Delivery Order.pdf");
    // },
    async createPDFnew() {
      var doc = new jsPDF();
      const data = [
        {
          num1: "2.1",
          desc1: "Name of ship: " + this.wdr.shipname,
          num2: "2.5",
          desc2: "Owner or operator: " + this.wdr.owner,
        },
        {
          num1: "2.2",
          desc1: "IMO number: " + this.wdr.imonumber,
          num2: "2.5",
          desc2: "Distinctive number of letters: " + this.wdr.distinctive,
        },
        {
          num1: "2.3",
          desc1: "Gross Tonnage: " + this.wdr.grosstonnage,
          num2: "2.7",
          desc2: "Flag State: " + this.wdr.flagstate,
        },
      ];
      const rows = data.map((obj) => [
        obj.num1,
        obj.desc1,
        obj.num2,
        obj.desc2,
      ]);

      const datas = [
        {
          num1: "2.4",
          desc1: "Type of ship:",
          num2: "Oil Tanker",
          desc2: "",
          num3: "Chemical Tanker",
          desc3: "",
          num4: "Bulk Carrier",
          desc4: "",
          num5: "Container",
          desc5: "",
        },
        {
          num1: "",
          desc1: "",
          num2: "Other cargo ship",
          desc2: "",
          num3: "Passenger ship",
          desc3: "",
          num4: "Ro-ro",
          desc4: "",
          num5: "Other (specify)",
          desc5: "",
        },
      ];
      const rowss = datas.map((obj) => [
        obj.num1,
        obj.desc1,
        obj.num2,
        obj.desc2,
        obj.num3,
        obj.desc3,
        obj.num4,
        obj.desc4,
        obj.num5,
        obj.desc5,
      ]);

      const data2 = [
        {
          num1: "1.1",
          desc1: "Location/Terminal name: " + this.wdr.locationname,
        },
        {
          num1: "1.2",
          desc1:
            "Reception facility provider(s): " + this.wdr.receptionfacility,
        },
        {
          num1: "1.3",
          desc1:
            "Treatment facility provider(s) - if different from above: " +
            this.wdr.treatmentfacility,
        },
        {
          num1: "1.4",
          desc1:
            "Waste Discharge Date: " +
            this.wdr.date +
            " and Time from: " +
            this.wdr.starttime +
            " to " +
            this.wdr.endtime,
        },
      ];
      const rows2 = data2.map((obj) => [obj.num1, obj.desc1]);

      const data3 = [
        {
          num1: "MARPOL Annex I - Oil",
          desc1: "Quantity (M³)",
          desc12: "Quantity (MT)",
          num2: "MARPOL Annex V - Garbage",
          desc2: "Quantity (M³)",
          desc22: "Quantity (MT)",
        },
        {
          num1: "Oily bilge water",
          desc1: this.aa,
          num2: "A. Plastics",
          desc2: this.a,
        },
        {
          num1: "Oil residues (sludge)",
          desc1: this.bb,
          num2: "B. Food wastes",
          desc2: this.b,
        },
        {
          num1: "Oily tank washings",
          desc1: this.cc,
          num2: "C. Domestic wastes (e.g. paper products, rags, glass, metal, bottles, crockery, etc.)",
          desc2: this.c,
        },
        {
          num1: "Dirty ballast water",
          desc1: this.dd,
          num2: "D. Cooking oil",
          desc2: this.d,
        },
        {
          num1: "Scale and sludge from tank cleaning",
          desc1: this.ee,
          num2: "E. Incinerator ashes",
          desc2: this.e,
        },
        {
          num1: "Other (please specify)",
          desc1: this.ff,
          num2: "F. Operational wastes",
          desc2: this.f,
        },
        {
          num1: "MARPOL Annex II - NLS",
          desc1: "",
          num2: "G. Cargo residues²",
          desc2: this.g,
        },
        {
          num1: "Category X substance",
          desc1: this.xpdf,
          num2: "H. Animal carcass(es)",
          desc2: this.h,
        },
        {
          num1: "Category Y substance",
          desc1: this.ypdf,
          num2: "I. Others: Fluorescent lamp",
          desc2: this.i,
        },
        {
          num1: "Category Z substance",
          desc1: this.zpdf,
          num2: "MARPOL Annex VI - related",
          desc2: "",
        },
        {
          num1: "OS - other substance",
          desc1: this.ospdf,
          num2: "Ozone-depleting substances and equipment containing such substances",
          desc2: this.ozone,
        },
        {
          num1: "MARPOL Annex IV - Sewage",
          desc1: "",
          num2: "Exhaust gas-cleaning residues",
          desc2: this.exhaust,
        },
        {
          num1: "",
          desc1: "",
          num2: "",
          desc2: "",
        },
      ];
      const rows3 = data3.map((obj) => [
        obj.num1,
        obj.desc1,
        obj.desc12,
        obj.num2,
        obj.desc2,
        obj.desc22,
      ]);

      const logo = new Image();
      logo.src = require("@/assets/img/afesneww.png");
      logo.onload = () => {
        this.options = Object.assign({}, this.options, {
          logo: {
            logo,
          },
        });
      };

      // var logoimage = "https://m.media-amazon.com/images/I/71T2m0TSIYL._AC_UF894,1000_QL80_.jpg";
      var logoimageurl = "";

      const logo1 = new Image();

      if (logoimageurl != "") {
        logo1.src = logoimageurl;
        logo1.onload = () => {
          this.options = Object.assign({}, this.options, {
            logo1: {
              logo1,
            },
          });
        };
      } else if (logoimageurl == "") {
        logo1.src = require("@/assets/img/blank.png");
        logo1.onload = () => {
          this.options = Object.assign({}, this.options, {
            logo1: {
              logo1,
            },
          });
        };
      }

      doc.setFontSize(9);
      doc.text("WDR NO: " + this.jobno + "", 150, 5);
      doc.setFontSize(10);

      doc.setFontStyle("bold");
      doc.text("WASTE DELIVERY RECEIPT", 80, 45);
      doc.setFontSize(8);

      doc.addImage(
        logo1,
        "PNG",
        doc.internal.pageSize.getWidth() - 200,
        5,
        65,
        30
      );

      doc.addImage(
        logo,
        "PNG",
        doc.internal.pageSize.getWidth() - 75,
        5,
        50,
        18.75
      );

      doc.setLineWidth(0.3); // Set line width
      doc.line(10, 35, doc.internal.pageSize.getWidth() - 10, 35);

      doc.setFontStyle("italic");
      doc.text(
        "This form should be retained on board the vessel along with the appropriate Oil RB, Cargo RB or Garbage RB.",
        10,
        50
      );
      doc.setFontStyle("normal");

      let startY1 = 55;

      doc.setFontSize(9);
      doc.setFontStyle("bold");

      doc.text("1.", 15, startY1);
      doc.text("RECEPTION FACILITY AND PORT", 25, startY1);

      doc.setFontSize(7);
      doc.setFontStyle("normal");
      const columnWidths = [8, 85, 8, 85];
      const column = [8, 178];

      const lastRowColumnWidths = [10, 26, 26, 10, 26, 10, 26, 10, 26, 10];
      doc.autoTable({
        body: rows2,
        startY: startY1 + 1,
        theme: "plain",

        columnStyles: {
          0: { columnWidth: column[0] },
          1: { columnWidth: column[1] },
        },

        didDrawCell: function (data) {
          doc.rect(
            data.cell.x,
            data.cell.y,
            data.cell.width,
            data.cell.height,
            "S"
          );
        },

        styles: {
          fontSize: 8,
        },
      });

      const columnWidthss = [8, 30, 29, 8, 29, 8, 29, 8, 29, 8];

      let startY2 = doc.autoTable.previous.finalY + 8;

      doc.setFontSize(9);
      doc.setFontStyle("bold");
      doc.text("2.", 15, startY2);
      doc.text("SHIP PARTICULARS", 25, startY2);

      doc.setFontSize(7);
      doc.setFontStyle("normal");
      doc.autoTable({
        body: rows,
        startY: startY2 + 1,
        theme: "plain",

        columnStyles: {
          0: { columnWidth: columnWidths[0] },
          1: { columnWidth: columnWidths[1] },
          2: { columnWidth: columnWidths[2] },
          3: { columnWidth: columnWidths[3] },
        },

        didDrawCell: function (data) {
          doc.rect(
            data.cell.x,
            data.cell.y,
            data.cell.width,
            data.cell.height,
            "S"
          );
        },

        styles: {
          fontSize: 8,
        },
      });

      // const columnWidthss = [8, 30, 29, 8, 29, 8, 29, 8, 29, 8];

      doc.autoTable({
        body: rowss,
        startY: doc.autoTable.previous.finalY,
        theme: "plain",

        columnStyles: {
          0: { columnWidth: columnWidthss[0] },
          1: { columnWidth: columnWidthss[1] },
          2: { columnWidth: columnWidthss[2] },
          3: { columnWidth: columnWidthss[3] },
          4: { columnWidth: columnWidthss[4] },
          5: { columnWidth: columnWidthss[5] },
          6: { columnWidth: columnWidthss[6] },
          7: { columnWidth: columnWidthss[7] },
          8: { columnWidth: columnWidthss[8] },
          9: { columnWidth: columnWidthss[9] },
        },

        didDrawCell: function (data) {
          doc.rect(
            data.cell.x,
            data.cell.y,
            data.cell.width,
            data.cell.height,
            "S"
          );
        },

        styles: {
          fontSize: 8,
        },
      });

      // doc.addPage();
      let startY3 = doc.autoTable.previous.finalY + 8;
      // let startY3 = 120;

      console.log(startY3);
      let startY4 = startY2 + doc.autoTable.previous.finalY + 8;

      doc.setFontSize(9);
      doc.setFontStyle("bold");
      doc.text("3.", 15, startY3);
      doc.text(
        "TYPE AND AMOUNT OF WASTES/RESIDUES FOR DISCHARGE TO FACILITY",
        25,
        startY3
      );

      const columnWidth = [42, 23, 23, 52, 23, 23];
      doc.autoTable({
        body: rows3,
        startY: startY3 + 1,
        theme: "plain",

        columnStyles: {
          0: { columnWidth: columnWidth[0] },
          1: { columnWidth: columnWidth[1] },
          2: { columnWidth: columnWidth[2] },
          3: { columnWidth: columnWidth[3] },
          4: { columnWidth: columnWidth[4] },
          5: { columnWidth: columnWidth[5] },
        },

        didDrawCell: function (data) {
          doc.rect(
            data.cell.x,
            data.cell.y,
            data.cell.width,
            data.cell.height,
            "S"
          );
        },

        styles: {
          fontSize: 8,
        },
      });

      doc.setFontSize(8);
      doc.setFontStyle("normal");

      let startY7 = startY3 + 110;
      doc.text(
        "On behalf of the port facility I confirm that the above wastes were delivered.",
        25,
        startY7 + 5
      );
      doc.text("Signature", 25, startY7 + 10);
      doc.text(":", 55, startY7 + 10);
      doc.text("Full Name and Company", 85, startY7 + 10);
      doc.text(":", 125, startY7 + 10);
      doc.text("Stamp", 85, startY7 + 15);

      doc.text("Client' signature", 25, startY7 + 25);
      doc.text(":", 55, startY7 + 25);
      doc.text("Full Name and Company", 85, startY7 + 25);
      doc.text(":", 125, startY7 + 25);
      doc.text("Stamp", 85, startY7 + 30);

      doc.text(
        "1  Indicate the proper shipping name of the NLS involved.",
        25,
        startY7 + 35
      );
      doc.text(
        "2  Indicate the proper shipping name of dry cargo.",
        25,
        startY7 + 38
      );
      doc.setLineWidth(0.3); // Set line width
      doc.line(
        10,
        startY7 + 39,
        doc.internal.pageSize.getWidth() - 10,
        startY7 + 39
      );

      doc.text("Remarks:", 25, startY7 + 45);
      doc.text(
        "1. Charges are based on the weight measured on the weighbridge.",
        25,
        startY7 + 48
      );
      doc.text(
        "2. WDR will be attach together with weighbridge chit for the claim purposes.",
        25,
        startY7 + 51
      );

      doc.save("Waste Delivery Order.pdf");

      console.log("pdf created");
    },
    // saveDraft() {},
    onFileChange(event) {
      this.upload = true;
      const t = event.target;

      this.document = t.files.length;

      var input;
      if (t.files.length > 0) {
        for (let i = 0; i < t.files.length; i++) {
          input = this.$refs.file.files[i];
          const formData = new FormData();
          formData.append("document", input);
          this.docs = formData;

          this.uploadload = true;
          this.buttondisabled = true;

          this.$http
            .post(
              ":10001/api/v1/incoming/" +
              this.jobno +
              "/upload/dispute-waste-job",
              this.docs,
              {
                headers: {
                  Authorization: `Bearer ${getStorage("token")}`,
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
              } else {
              }
            });
          this.uploadload = false;
          this.buttondisabled = false;
        }
      }
    },
    dispute() {
      if (this.reason != "") {
        let obj = {
          dispute_reason: this.reason,
        };
        this.$http
          .post(":10001/api/v1/incoming/" + this.jobno + "/dispute", obj)
          .then((res) => {
            if (!res.error) {
              let response = res.message;
              console.log(response);

              // swal({
              //   title: `Success!`,
              //   text: response,
              //   buttonsStyling: false,
              //   confirmButtonClass: "btn btn-primary btn-fill",
              //   type: "success",
              // });

              this.modals.disputereason = false;
              this.exitTab();
            }
          });
      } else {
        // reason is compulsory
        swal({
          title: `Info!`,
          text: "Please fill in the reason",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-primary btn-fill",
          type: "warning",
        });
      }
    },
    accept() {
      this.$http
        .post(":10001/api/v1/incoming/" + this.jobno + "/accept")
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = response;
            this.modals.successModal = true;
            // swal({
            //   title: `Success!`,
            //   text: response,
            //   buttonsStyling: false,
            //   confirmButtonClass: "btn btn-primary btn-fill",
            //   type: "success",
            // });

            this.modals.disputereason = false;
            setTimeout(() => {
              this.nextTab();
            }, 1000);
          }
        });
    },
    getDetail(refNo) {
      this.wastedetails = [];
      this.labreport = [];
      this.signeddo = [];

      this.$http.get(":10001/api/v1/incoming/scrap/" + refNo).then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log("data is here", response);

          // this.landvesselflag = response.company.company_type.toUpperCase();
          if (typeof response.dashboard_step == 'string') {
            this.step = Number(response.dashboard_step)
          } else if (typeof response.dashboard_step == 'number') {
            this.step = response.dashboard_step;
          } else {
            this.step = response.dashboard_step;
          }
          this.collectiondate = moment(response.collection_date).format(
            "DD.MM.YYYY"
          );
          this.servicelocation = response.service_location.service_location;
          this.servicelocationcollection =
            response.service_location.collection_location;
          this.companyName = response.company.company_name;
          this.companyAddress = response.company.company_address;

          this.phoneNoFaxNo =
            (response.company.company_phone_number == "" ||
              response.company.company_phone_number == null
              ? "N/A"
              : response.company.company_phone_number) +
            " / " +
            (response.company.company_fax_number == "" ||
              response.company.company_fax_number == null
              ? "N/A"
              : response.company.company_fax_number);
          this.picFullName = response.pic.pic_name;
          this.picPhoneNoFaxNo =
            (response.pic.pic_phone_number == "" ||
              response.pic.pic_phone_number == null
              ? "N/A"
              : response.pic.pic_phone_number) +
            " / " +
            (response.pic.pic_fax_number == "" ||
              response.pic.pic_fax_number == null
              ? "N/A"
              : response.pic.pic_fax_number);

          this.picEmail = response.pic.pic_email;

          this.wastecomponent = [];

          for (var i = 0; i < response.waste_details.length; i++) {
            let combinedName = "";
            for (
              var j = 0;
              j < response.waste_details[i].waste_components.length;
              j++
            ) {
              if (j > 0) {
                combinedName += ", "; // Add a separator between component names
              }
              combinedName += String(
                response.waste_details[i].waste_components[j].component_name
              );
            }
            let obj = {
              name: combinedName,
            };
            this.wastecomponent.push(obj);
          }

          for (var i = 0; i < response.waste_details.length; i++) {
            let obj = {
              no: i + 1,
              waste:
                response.waste_details[i].waste_type_name + ", " + response.waste_details[i].waste_sub_type_name,
              // +
              // "\n" +
              // "Origin: " +
              // response.waste_details[i].waste_origin +
              // "\n" +
              // "Waste Component: " +
              // this.wastecomponent[i].name +
              // "\n" +
              // "Remark: " +
              // response.waste_details[i].remark, // tambah sub type
              est:
                response.waste_details[i].estimated_quantity.toString(),
              // +
              // " " +
              // response.waste_details[i].estimated_quantity_unit,
              pack:
                response.waste_details[i].packaging_quantity.toString() +
                " " +
                response.waste_details[i].packaging_type_name,

              wastetype:
                response.waste_details[i].waste_type_name == ""
                  ? "N/A"
                  : response.waste_details[i].waste_type_name,
              packagingtype:
                response.waste_details[i].packaging_type_name == ""
                  ? "N/A"
                  : response.waste_details[i].packaging_type_name,
              wasteorigin: response.waste_details[i].waste_origin,
              wastecomponent: response.waste_details[i].waste_components,
              estqty: response.waste_details[i].estimated_quantity,
              estqtyunit: response.waste_details[i].estimated_quantity_unit,
              calqty: response.waste_details[i].calculated_quantity,
              calqtyunit: response.waste_details[i].calculated_quantity_unit,
              packagingqty: response.waste_details[i].packaging_quantity,
              packagingqtyunit: response.waste_details[i].packaging_type_name,
              remarks: response.waste_details[i].remark,
              image: response.waste_details[i].images,
            };

            this.wastedetails.push(obj);
          }

          // get lab report
          if (response.lab_report != null) {
            this.labreport.push(response.lab_report);
          }

          // get signed do
          if (response.signed_wdo != null) {
            for (var i = 0; i < response.signed_wdo.length; i++) {
              let obj = {
                fileid: response.signed_wdo[i].wdr_support_document_id,
                filename: response.signed_wdo[i].meta.filename,
                fileurl: response.signed_wdo[i].url,
                rev: response.signed_wdo[i].rev,
              };
              this.signeddo.push(obj);
            }
          }
        }
      });
    },

    ptwTab() {
      let parameter = {
        step: "2",
        direction: "depan",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    async exitTab() {
      let parameter = {
        step: "1",
        direction: "blkg",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        let style = { background: "#FFFFFF", color: "#15cf79" };
        return style;
      } else {
        let style = { background: "#f5f6fa", color: "#959595" };
        return style;
      }
    },
    getScroll() {
      this.scroll = true;
    },
    getScroll2() {
      this.scroll = false;
    },
    onImageChange(file) {
      this.images.regular = file;

      this.img = file.name;

      const reader = new FileReader();

      reader.onload = (event) => {
        file = event.target.result;

        file.replace(event.target.result);

        this.imagebase64 = file.split(",")[1];
      };
      reader.readAsDataURL(file);
    },
    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$root.$emit("image", this.imagebase64);
        return res;
      });
    },
  },
  watch: {
    // jobstatus() {
    //   if (this.jobstatus.toUpperCase() == "QUOTATION") {
    //     this.nextTab();
    //   }
    //   if (this.jobstatus.toUpperCase() == "PTW") {
    //     this.ptwTab();
    //   }
    // },
    step() {
      console.log(this.step);

      // if (this.step == 1) {
      // }
      // if (this.step == 2) {
      //   let parameter = {
      //     step: "1",
      //     direction: "depan",
      //     data: [],
      //   };
      //   this.$emit("my-event", parameter);
      // }
      // if (this.step == 3) {
      //   let parameter = {
      //     step: "2",
      //     direction: "depan",
      //     data: [],
      //   };
      //   this.$emit("my-event", parameter);
      // }
      // if (this.step == 4) {
      //   let parameter = {
      //     step: "3",
      //     direction: "depan",
      //     data: [],
      //   };
      //   this.$emit("my-event", parameter);
      // }
      // if (this.step == 5) {
      //   let parameter = {
      //     step: "4",
      //     direction: "depan",
      //     data: [],
      //   };
      //   this.$emit("my-event", parameter);
      // }
      // if (this.step == 6) {
      //   let parameter = {
      //     step: "5",
      //     direction: "depan",
      //     data: [],
      //   };
      //   this.$emit("my-event", parameter);
      // }
    },
  },
};
</script>
<style scoped>
.textarea {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 1px solid #2b3553;
  border-radius: 4px;
  background-color: transparent;
  font-size: 14px;
  resize: none;
  /* color: #1d253b; */
}

.textarea:focus {
  outline: none !important;
  border: 1px solid #1d8cf8;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out;
  background-color: 0.3s ease-in-out;
}

.address {
  width: 100%;
  height: 100px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}

.huraian {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}

.new-title {
  margin-top: 20px;
  color: #A5A5A5;
}

.subtitle {
  color: #A5A5A5;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}

.scrollable {
  height: 500px;
  overflow-y: scroll;
  padding: 0px 0px 0px 30px;
  color: #A5A5A5;
}

.floating-buttons-container {
  position: relative;
  width: 100%;
  height: 100vh;
}

/* Styles for floating buttons */
.floating-buttons {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  width: 80px;
  z-index: 9999;
  left: 20px;
  /* Adjust as needed */
}

/* Styles for individual buttons */
.left-button,
.right-button {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #358CCB;
  /* You can change the color as desired */
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  cursor: pointer;
}

.scrollable-row {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  margin-bottom: 15px;
  /* Adjust as needed */
}

.scrollable-content {
  flex: 0 0 auto;
  white-space: nowrap;
  margin-right: 15px;
  /* Adjust as needed */
}

.el-table .cell {
  word-break: break-word !important;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #dce9ff;
  border-radius: 15px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #5e99ff;
  border-radius: 15px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #176bfd;
}

.newtitle {
  color: #707070;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}

.sub-titles {
  margin-top: -5px;
  color: #A5A5A5;
}
</style>
